// extracted by mini-css-extract-plugin
export var active = "_gg-7";
export var blink = "_gg-8";
export var dropDownSelector = "_gg-4";
export var dropDownWrapper = "_gg-3";
export var fakeCursor = "_gg-6";
export var fontSizeButton = "_gg-9";
export var formQuillEditor = "_gg-0";
export var pressed = "_gg-a";
export var qlBlank = "_gg-1";
export var textFormattingToolbar = "_gg-2";
export var textToolbarOption = "_gg-5";